const getProgress = state => module => state.progress[module];
const getSlideState = state => (module, slide) => (state.slideStates[module][slide] || {});

export default {
    getProgress,
    getSlideState
};
